(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('ediMenu', {
        templateUrl: 'views/components/views/ediMenu/ediMenu.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', function (stateService) {
            const vm = this;

            vm.model = {
                name: stateService.getCurrentName()
            };
        }]
    });
})();
